import axios from "axios";
import Cookies from 'universal-cookie';

const REST_URL = process.env.REACT_APP_REST_URL;
const cookies = new Cookies();
const token = cookies.get('token');
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

export const auth = (phone, password) => {
    return new Promise((resolve, reject) => {
        axios.post(REST_URL + '/api/login', { PhoneNumber: phone, Password: password })
            .then(function (response) {
                resolve(response.data)
            })
            .catch(function (error) {
                reject(error)
                console.log(error);
            })
    })
};

export const registration = (data) => {
    return new Promise((resolve, reject) => {
        axios.post(REST_URL + '/api/registration', data)
            .then(function (response) {
                resolve(response.data)
            })
            .catch(function (error) {
                reject(error)
                console.log(error);
            })
    })
}

export const getMarks = () => {
    return new Promise((resolve, reject) => {
        axios.get(REST_URL + '/api/mark')
            .then(function (response) {
                resolve(response.data)
            })
            .catch(function (error) {
                console.log(error);
            })
    })
};

export const getCities = () => {
    return new Promise((resolve, reject) => {
        axios.get(REST_URL + '/api/city')
            .then(function (response) {
                resolve(response.data)
            })
            .catch(function (error) {
                console.log(error);
            })
    })
};

export const getPriceSegments = () => {
    return new Promise((resolve, reject) => {
        axios.get(REST_URL + '/api/priceSegment')
            .then(function (response) {
                resolve(response.data)
            })
            .catch(function (error) {
                console.log(error);
            })
    })
}

export const setFilters = (data) => {
    return new Promise((resolve, reject) => {
        axios.post(REST_URL + '/api/filters/setToUser', data)
            .then(function (response) {
                resolve(response.data)
            })
            .catch(function (error) {
                console.log(error);
            })
    })
}

export const getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        axios.get(REST_URL + '/api/users/currentUser')
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            })
    })
};

export const getCurrentBiddings = (limit, offset) => {
    return new Promise((resolve, reject) => {
        axios.get(REST_URL + '/api/bidding/currentBiddings?limit=' + limit + '&offset=' + offset)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            })
    })
};

export const getCompletedBiddings = (limit, offset) => {
    return new Promise((resolve, reject) => {
        axios.get(REST_URL + '/api/bidding/completedBiddings?limit=' + limit + '&offset=' + offset)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            })
    })
};

export const getBiddingById = (id) => {
    return new Promise((resolve, reject) => {
        axios.get(REST_URL + `/api/bidding/${id}`)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            })
    })
}

export const betBidding = (data) => {
    return new Promise((resolve, reject) => {
        axios.post(REST_URL + `/api/bidding/bet`, data)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            })
    })
}

export const tryBet = (data) => {
    return new Promise((resolve, reject) => {
        axios.post(REST_URL + `/api/bidding/tryBet`, data)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            })
    })
}

export const getNotifications = () => {
    return new Promise((resolve, reject) => {
        axios.get(REST_URL + `/api/notifications`)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            })
    })
}
export const getTariffs = () => {
    return new Promise((resolve, reject) => {
        axios.get(REST_URL + `/api/tariff`)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            })
    })
}

export const markNotificationAsRead = (data) => {
    return new Promise((resolve, reject) => {
        axios.patch(REST_URL + `/api/notifications/markAsRead`, data)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            })
    })
}

export const markAllNotificationsAsRead = (data) => {
    return new Promise((resolve, reject) => {
        axios.patch(REST_URL + `/api/notifications/markAllAsRead`, data)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            })
    })
}

export const createPayment = (data) => {
    return new Promise((resolve, reject) => {
        axios.post(REST_URL + `/api/payment/createPayment`, data)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(function (error) {
                reject(error);
            })
    })
}